export default "__VITE_ASSET__Cs1n9qgl__"